import $ from "jquery";

const addtionalOptionPrice = () => {
  const init = () => {
    $(function () {
      exec();
      appendStock();
    });
  };

  const exec = () => {
    $(function () {
      const selectElement = "#select-option";
      // const selectElementOption = $("#select-option option:first");
      // const originalPriceElement = $(
      //   ".inner-sec-info .woocommerce-Price-amount.amount bdi"
      // );

      //  Get price text
      // const originalPriceText = originalPriceElement.text();

      // Remove non-digit characters and commas to get the price value
      // const originalPrice = parseFloat(
      //   originalPriceText.replace(/[^\d,]/g, "").replace(",", ".")
      // );

      $(selectElement).on("change", function () {
        // const selectedOption = $(this).val();
        // let selectedOptionText;

        const $priceElement = $(".css-product-price p.price .amount");

        $priceElement.replaceWith(
          $(this).find("option:selected").data("price-total")
        );

        // if (!selectedOption) {
        //   selectedOptionText = $(this).val();
        // } else {
        //   selectedOptionText = $(this).text();
        // }

        // const newSelectedOptionText = selectedOptionText;

        // // Check if the selected option contains numbers in the format (+€ X )
        // const matches = newSelectedOptionText.match(/\(\+€ (\d+(\.\d+)?) \)/);

        // if (matches) {
        //   const additionalPrice = parseFloat(matches[1]); // Take additional numbers from the options

        //   // Check if the selected value is a valid number
        //   if (!isNaN(additionalPrice)) {
        //     const newPrice = originalPrice + additionalPrice;

        //     // Format prices with appropriate currency and decimal symbols
        //     const currencySymbol = "€";
        //     const formattedPrice =
        //       currencySymbol + newPrice.toFixed(2).replace(".", ",");

        //     // Update price display on WooCommerce product page
        //     originalPriceElement.text(formattedPrice);
        //   }
        // } else if (newSelectedOptionText === selectElementOption.val()) {
        //   // If the first select option is selected, return the price to the original price
        //   originalPriceElement.text(originalPriceText);
        // }
      });
    });
  };

  const appendStock = () => {
    $(function () {
      const stockElement = $(".inner-sec-info .stock");
      const formElement = $(".inner-sec-info .cart");

      formElement.prepend(stockElement);
    });
  };

  init();
};

try {
  addtionalOptionPrice();
} catch (e) {
  console.error(e);
}
